import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { isProductionRuntime } from '@/lib/app-env';
import { ROUTES } from '@/lib/route-paths';

/**
 * Layout gate for every `/dashboard/wireframes/*` page.
 *
 * The wireframes are design artifacts — fixtures only, nothing in the product
 * links to them — but the routes still ship in the bundle, so any authed user
 * who knows (or guesses) the URL could open them in production. #1008 kept the
 * wireframe chrome off product routes; this keeps the wireframe pages
 * themselves out of production entirely.
 *
 * Same runtime read as `/dashboard/website` — see `lib/app-env.ts` for why
 * this is a runtime check and not a build-time one.
 */
export const Route = createFileRoute('/_authed/dashboard/wireframes')({
  beforeLoad: () => {
    if (isProductionRuntime()) {
      throw redirect({ to: ROUTES.dashboard });
    }
  },
  component: WireframesLayout,
});

function WireframesLayout() {
  return <Outlet />;
}
